import { ISupplier_SeoVideo } from '@bridebook/models/source/models/Suppliers.types';
import { parseVideo } from '@bridebook/toolbox/src/validation/parse-video';

type VideoThumbnailQuality = 'hqdefault' | 'maxresdefault';

export const getSupplierVideoId = (seoVideo?: ISupplier_SeoVideo): string | undefined => {
  if (seoVideo?.videoId) return seoVideo.videoId;
  const parsed = seoVideo?.youtubeUrl ? parseVideo(seoVideo.youtubeUrl) : undefined;
  return parsed?.type === 'youtube' ? parsed.id : undefined;
};

export const getSupplierVideoEmbedUrl = (videoId: string): string =>
  `https://www.youtube.com/embed/${videoId}`;

export const getSupplierVideoWatchUrl = (videoId: string): string =>
  `https://www.youtube.com/watch?v=${videoId}`;

/**
 * Thumbnail for a supplier video: the stored override, otherwise the derived img.youtube.com URL.
 * `hqdefault` (480×360) suits compact UI; `maxresdefault` (1280×720) suits og:image.
 */
export const getSupplierVideoThumbnail = (
  seoVideo: ISupplier_SeoVideo | undefined,
  videoId: string,
  quality: VideoThumbnailQuality = 'hqdefault',
): string => seoVideo?.thumbnailUrl || `https://img.youtube.com/vi/${videoId}/${quality}.jpg`;
